import React from 'react';
import { Group } from 'src/design/atoms/Group';
import { Paper } from 'src/design/atoms/Paper';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import { Title } from 'src/design/atoms/Title';
import { LinkButton } from 'src/design/atoms/LinkButton';

export interface IReportCardProps {
  title: string;
  description: string;
  link: string;
  target?: React.HTMLAttributeAnchorTarget;
}

/** @registry Card linking out to a report, sized to fill a grid cell with the action pinned to the bottom. */
export const ReportCard: React.FC<IReportCardProps> = ({
  title,
  description,
  link,
  target = '_self',
}) => {
  return (
    <Paper>
      <Stack h="100%" justify="space-between">
        <Stack gap="xs">
          <Title order={4}>{title}</Title>
          <Text>{description}</Text>
        </Stack>
        <Group justify="flex-end">
          <LinkButton to={link} target={target}>
            View Report
          </LinkButton>
        </Group>
      </Stack>
    </Paper>
  );
};
